import React from 'react';
import SearchComponent from './SearchComponent';
import ProcessFlowGraph from './ProcessFlowGraph';
import "./styles.css";
import { FlowProvider } from './FlowContext';
import { SearchResult } from './types';
import { useStore } from './store';
import SignInButton from './SignInButton';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import AuthWrapper from './AuthWrapper';
import Banner from './Banner';
import { useAuth } from './auth';
import { BrowserRouter } from 'react-router-dom';
import PageRoutes from './PageRoutes';


const App = () => {
  

  return <BrowserRouter>
    <PageRoutes />
</BrowserRouter>;
};

export default App;
